var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardCheckFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.119 18.125 4.917-4.95a.94.94 0 0 1 .696-.275q.422 0 .695.275a.95.95 0 0 1 .273.7.95.95 0 0 1-.273.7l-5.613 5.65a.95.95 0 0 1-.696.3.95.95 0 0 1-.695-.3l-2.831-2.85a.95.95 0 0 1-.274-.7q0-.425.274-.7a.94.94 0 0 1 .695-.275q.422 0 .695.275zM4.686 22a1.9 1.9 0 0 1-1.403-.587A1.93 1.93 0 0 1 2.7 20V6q0-.824.584-1.412T4.687 4h4.148q.273-.875 1.068-1.437A2.95 2.95 0 0 1 11.64 2q.994 0 1.776.563.783.562 1.056 1.437h4.123q.82 0 1.403.588.584.587.584 1.412v4q0 .424-.286.713a.96.96 0 0 1-.708.287.96.96 0 0 1-.708-.287.97.97 0 0 1-.285-.713V6h-1.987v2a.97.97 0 0 1-.286.713.96.96 0 0 1-.708.287H7.668a.96.96 0 0 1-.708-.287A.97.97 0 0 1 6.674 8V6H4.687v14h4.967q.423 0 .708.288.285.287.286.712 0 .424-.286.712a.96.96 0 0 1-.708.288zm6.954-16a.96.96 0 0 0 .708-.287.97.97 0 0 0 .286-.713.97.97 0 0 0-.286-.713.96.96 0 0 0-.708-.287.96.96 0 0 0-.707.287.97.97 0 0 0-.286.713q0 .424.286.713.285.287.707.287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheckFill);
export default __webpack_public_path__ + "static/media/clipboard_check_fill.a23cb9d704df3ab6112c297738020792.svg";
export { ForwardRef as ReactComponent };